import { RootState } from 'store';

export const getFormsInvitationLoading = (state: RootState): boolean =>
    state.formsInvitation.loading;

export const getFormsInvitationData = (state: RootState) => state.formsInvitation.data;

export const getFormsInvitationCurrentView = (state: RootState) =>
    state.formsInvitation.currentView;

export const getFormsInvitationAnswers = (state: RootState) => state.formsInvitation.answers;

export const getFormsInvitationResponseIds = (state: RootState) =>
    state.formsInvitation.responseIds;

export const getFormsInvitationError = (state: RootState) => state.formsInvitation.error;

export const getNotifyAddQuestionShown = (state: RootState): boolean =>
    state.formsInvitation.notifyAddQuestionShown;

export const getNotifyAddPetShown = (state: RootState): boolean =>
    state.formsInvitation.notifyAddPetShown;
